import {ISkCrossDomMgr, OSkExecInternalOptions, SkContext} from "lib/edit/schema/schema";

export interface IXmlIdMgr extends ISkCrossDomMgr {

	/**
	 * Met à jour la map des ID.
	 * @return 'conflict' si cet id est en conflit
	 */
	updateMap(id: string, fromAtt: Attr, skCtx: SkContext, abortIfConflict: boolean): 'conflict' | void

	/**
	 * Génére un nouvel ID.
	 * @param Set d'id déjà utilisés/créés dans cette session de traitements à exclure en plus (pas encore réinjectés dans la map courante).
	 */
	generateId(createdIds: Set<string>): string
}

class XmlIdMgr implements IXmlIdMgr {

	//public schemaDom: SchemaDom;

	map: Map<string, Attr | Attr[]> = new Map();

	constructor(/*schemaDom: SchemaDom*/) {
		//this.schemaDom = schemaDom
	}

	/**
	 * Note : comme on n'a pas d'evt qui détecte la suppr d'un attr, et qu'on ne dispose pas de la valeur précédente
	 * on doit controler systématiquement que l'attr est toujours connecté et egal à son id d'indexation dans la map.
	 */
	onStartValid(options: OSkExecInternalOptions): void {
		if (options.genAnnots) {
			if (options.resetAll) {
				this.map.clear();
			} else {
				for (const [id, atts] of this.map) {
					if (Array.isArray(atts)) {
						//Cas de conflit existant, on purger les cas de disparition de doublons
						for (let i = 0; i < atts.length; i++) {
							const att = atts[i];
							if (att.nodeValue !== id || !att.ownerElement?.isConnected) atts.splice(i--, 1);
						}
						if (atts.length === 0) {
							//Plus aucun id en conflit connecté
							this.map.delete(id);
						} else if (atts.length === 1) {
							//1 id restant, plus de conflit
							const att = atts[0];
							//On réaffecte la map en mode normal 1 id -> 1 att
							this.map.set(id, att);
							//On notifie l'élement de cet att pour clean des annots.
							(options.shouldRevalid || (options.shouldRevalid = new Set())).add(att.ownerElement);
						}
					} else {
						//Une seule valeur
						if (atts.nodeValue !== id || !atts.ownerElement?.isConnected) this.map.delete(id);
					}
				}
			}
		}
	}

	updateMap(id: string, fromAtt: Attr, skCtx: SkContext, abortIfConflict: boolean): 'conflict' | void {
		let ref: Attr | Attr[] = this.map.get(id);
		if (ref === undefined) {
			//Cas normal, on ajoute
			this.map.set(id, fromAtt);
			return;
		}
		//On check si les attr actuels sont toujours dans le document
		if (Array.isArray(ref)) {
			let found = ref.indexOf(fromAtt);
			if (found === 0 && ref.length === 1) {
				//Retour au cas normal, on clean le tableau
				this.map.set(id, fromAtt);
				return;
			} else if (found === -1 && !abortIfConflict) {
				//On ajoute ce nouvel attribut dans la liste des conflits.
				ref.push(fromAtt);
			}
		} else if (ref === fromAtt) {
			//cas normal déjà référencé
			return;
		} else {
			//On se trouve face à un conflit
			//1er cas de conflit détecté pour cet ID, on force un recalcul de l'autre attr
			const execOpt = skCtx.execOptions;
			(execOpt.shouldRevalid || (execOpt.shouldRevalid = new Set())).add(ref.ownerElement);
			//on place le conflit dans le tableau
			if (!abortIfConflict) {
				ref = [ref, fromAtt];
				this.map.set(id, ref);
			}
		}
		return 'conflict';
	}

	/**
	 * génère 2 chars aléatoires minimum qui sont différents des ids présents dans this.map et createdIds.
	 */
	generateId(createdIds: Set<string>): string {
		let start = FIRSTCHARS.charAt(Math.floor(Math.random() * FIRSTCHARS.length));
		let next = Math.floor(Math.random() * NEXTCHARS.length);
		let id = start + NEXTCHARS[next];
		while (this.map.has(id) || createdIds.has(id)) {
			const tested = next;
			if (++next === NEXTCHARS.length) next = 0;
			while (tested !== next) {
				//On boucle sur toutes les possiblités pour ce char next.
				id = start + NEXTCHARS[next];
				if (!this.map.has(id) && !createdIds.has(id)) return id;
				if (++next === NEXTCHARS.length) next = 0;
			}
			//Tout est utilisé, on ajoute un char
			start += NEXTCHARS[tested];
			next = Math.floor(Math.random() * NEXTCHARS.length);
			id = start + NEXTCHARS[next];
		}
		return id;
	}
}

const FIRSTCHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NEXTCHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";


export const crossDomMgrFactory = (config:Element) => (/*schemaDom: SchemaDom*/) => new XmlIdMgr();

